import { useEffect } from 'react';

const GA_MEASUREMENT_ID = 'G-XPYQHVKHTM';
const GA_SRC = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
const FB_PIXEL_ID = '1577008955815268';
const FB_SRC = 'https://connect.facebook.net/en_US/fbevents.js';

declare global {
  interface Window {
    dataLayer: unknown[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag: (...args: any[]) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbq: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _fbq: any;
  }
}

export const TrackingScripts: React.FC = () => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;

    if (!document.querySelector(`script[src="${GA_SRC}"]`)) {
      const gaScript = document.createElement('script');
      gaScript.async = true;
      gaScript.src = GA_SRC;
      document.head.appendChild(gaScript);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('config', GA_MEASUREMENT_ID);
    }

    if (!window.fbq) {
      /* eslint-disable @typescript-eslint/no-explicit-any, prefer-rest-params, prefer-spread */
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window.fbq = n;
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      /* eslint-enable @typescript-eslint/no-explicit-any, prefer-rest-params, prefer-spread */

      if (!document.querySelector(`script[src="${FB_SRC}"]`)) {
        const fbScript = document.createElement('script');
        fbScript.async = true;
        fbScript.src = FB_SRC;
        document.head.appendChild(fbScript);
      }

      window.fbq('init', FB_PIXEL_ID);
      window.fbq('track', 'PageView');
    }
  }, []);

  return null;
};
